<div class="venue-container">

<ngx-spinner
  bdColor="rgba(75, 55, 100, 0.5)"
  size="large"
  color="#fff"
  type="line-scale-pulse-out">
      <span class="chevron left"></span>
      <span class="chevron right"></span>
</ngx-spinner>

  <div class="search-row align-center">
    <button class="btn dark-btn" (click)="createNew()">
      Create New Venue
    </button>
   <div class="input-with-icon align-row">
      <div class="input-icon align-center"><i class="flaticon-search"></i></div>
      <input
        type="text"
        placeholder="Search"
        (keyup)="search()"
        [(ngModel)]="searchText"
        class="searchtext"
    />
    </div>
  </div>
  <div class="venue-table">
    <div class="data-row" *ngFor="let venue of displayVenues">
      <div class="data-row-content ">
        <div class="content-cell">
          <div class="cell-row">
            <h3>{{venue.name}}</h3>
            <button class="btn dark-btn edit-btn" (click)="edit(venue.venueId)">
              Edit
            </button>
          </div>
          <div class="cell-row">       
            <div class="section-group-container">
              <label>Sections</label>
              <div class="section-container">
                <div *ngFor="let section of venue.venueSections" class="list-item align-center">
                  <span>{{section.name}}</span>
                </div>
              </div>
              <label>Groups</label>
              <div class="group-container">
                <div *ngFor="let group of venue.venueGroups" class="list-item align-center">
                  <span>{{group}}</span>
                </div>
              </div>
            </div>
            <div class="img-container align-center"> 
              <img 
                alt="" [src]="venue.imageUrl" 
                onerror="if (this.src != 'assets/app/media/img/error/img-not-found.png') 
                  this.src = 'assets/app/media/img/error/img-not-found.png';">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="displayVenues === undefined || displayVenues.length === 0"> No venues to show, click 'Create New Venue' to begin </div>
  </div>
</div>
